var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{ref:"addressInput",class:_vm.cssClass,attrs:{"id":"addressInput","placeholder":_vm.placeholder,"value":_vm.value,"state":_vm.validationState,"autocomplete":"address-line1","autofill":"off","required":_vm.required},on:{"input":function($event){return _vm.updateValue($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }